import { matterPaths } from '@/routing/paths'

/**
 * Replace the current `m/:matterId` segment in a dashboard path.
 *
 * Most routes keep everything after `m/:matterId` intact, but some routes have
 * matter-scoped IDs in the remainder of the path (e.g. User Files folder IDs).
 * Those routes may intentionally drop extra segments when switching matters.
 */
export const replaceMatterSegment = (path: string, newMatterParam: string): string => {
  // User Files: folder ids are matter-scoped. When the matter changes, always reset
  // to the destination matter's root drive route instead of carrying folderId.
  // Handle both old pattern (/dashboard/user-files/m/:matterId) and new pattern (/dashboard/m/:matterId/user-files)
  if (path.startsWith('/dashboard/user-files') || (path.includes('/m/') && path.includes('/user-files'))) {
    return matterPaths.userFiles.root(newMatterParam)
  }

  return path.replace(/\/m\/[^/]+/, `/m/${newMatterParam}`)
}
